import script from "./EditModel.vue?vue&type=script&setup=true&lang=js"
export * from "./EditModel.vue?vue&type=script&setup=true&lang=js"

import "./EditModel.vue?vue&type=style&index=0&id=9d0fec12&lang=less"

const __exports__ = script;

export default __exports__